<template>
  <ul class="cover-list">
    <li
      v-for="(item, index) in dataList"
      :key="index"
      :class="[
        (index + 1) % num == 0 ? 'item-noMargin' : '',
        num == 6
          ? 'vitem-item'
          : num == 4 && dataList.length > 4
          ? 'vitem-item4 vitem-item'
          : 'vitem-item4 vitem-item margin4',
      ]"
      @click="handletoPage(item.comicId,item.currentChapterId)"
    >
      <div :class="'vitem-cover'">
        <img  @dragstart.prevent 
          :src="item.realCoverUrl"
          alt=""
          class="vitem-cover-img"
          :class="[
            num == 6 ? 'vitem-cover-img' : num == 4 ? 'vitem-cover-img4' : '',
          ]"
        />
        <div class="vitem-tag" v-if="num == 6">
          <span>{{item.totalNum}}话</span>
          <p class="vitem-zan">
            <img  @dragstart.prevent  src="../assets/image/icon_dianzan.png" alt="" />
            <span>{{item.likeNumSum}}</span>
          </p>
        </div>
      </div>
      <p class="vitem-name">{{ item.comicName }}</p>
      <p class="vitem4-balance" v-if="num == 4">
        <span>{{item.currentNum ? item.currentNum : 1}}话</span>
        <span>/{{item.totalNum}}话</span>
      </p>
      <div v-if="num == 6" class="mask"></div>
    </li>
  </ul>
</template>

<script setup>
import { toRefs, toRaw, watch, onMounted } from "vue";
import { navTo, navToDetail } from '../utils/utils'
const props = defineProps({
  dataList: Array,
  num: Number,
  type:String
});
const handletoPage = (comicId,chapterId)=>{
  // if(props.tupe == 'gkls'){
  //   navTo("/comicContent",{chapterId:chapterId ,comicId:comicId})
  // }else{
    navToDetail(comicId)
  // }
}
</script>

<style lang="scss" scoped>
.cover-list {
  // width: 1188px;
  display: flex;
  height: auto;
  flex-wrap: wrap;
  margin: 0 auto;

  .vitem-item {
    cursor: pointer;
    margin-right: 19px;
    height: auto;
    overflow-x: hidden;
    width: 182px;
    position: relative;
    // border-radius: 10px;
    .mask {
      width: 182px;
      height: 273px;
      position: absolute;
      background: rgba(0, 0, 0, 0.25);
      opacity: 0;
      top: 0;
      right: 0;
      border-radius: 10px;
      overflow: hidden;
      pointer-events: none;
      transition: all 0.5s; /* 上浮这个过程需要的时间 */
    }

    .vitem-cover {
      position: relative;

      .vitem-cover-img {
        width: 182px;
        height: 273px;
        border-radius: 10px;
        margin-bottom: 10px;
      }

      .vitem-tag {
        width: 100%;
        height: 27px;
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: 0 14px;
        box-sizing: border-box;
        line-height: 20px;
        position: absolute;
        bottom: 0px;
        z-index: 3;
        background: linear-gradient(to bottom, #ffffff00, rgba(0, 0, 0, 0.9));
        border-radius: 0 0 10px 10px;
        span {
          font-size: 14px;
          font-family: PingFangSC, PingFang SC;
          font-weight: 400;font-weight: lighter;
          color: #fff;
        }

        .vitem-zan {
          display: flex;
          align-items: center;

          img {
            width: 14px;
            height: 14px;
          }
        }
      }
    }

    .vitem-name {
      font-size: 18px;
      font-family: PingFangSC, PingFang SC;
      
      color: #333333;
      line-height: 25px;
      width: 100%;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }

    &:hover {
      .vitem-name {
        color: #cb2945 !important;
      }
      .vitem-cover {
        box-shadow: 0px 0px 8px 0px rgba(29, 30, 31, 0.3);
        border-radius: 10px;
      }
      .mask {
        opacity: 1;
      }
    }
  }

  .vitem-item4 {
    width: 200px;
    margin-right: 28px;
    margin-bottom: 20px;

    .vitem-cover {
      position: relative;

      .vitem-cover-img4 {
        width: 200px;
        height: 300px;
        border-radius: 10px;
        margin-bottom: 10px;
      }
    }

    .vitem4-balance {
      font-size: 14px;
      font-weight: 400;font-weight: lighter;
      line-height: 20px;

      span:nth-child(1) {
        color: #cb2945;
        margin-bottom: 6px;
      }
      span:nth-child(2) {
        color: #666;
      }
    }
    &:hover {
      .vitem-name {
        color: #333333 !important;
      }
      .vitem-cover {
        box-shadow: none;
      }
    }
  }
  .margin4 {
    margin-right: 33px;
  }

  .item-noMargin {
    margin-right: 0;
  }
}
</style>
